export const interAction = {
  take: "take",
  watch: "watch",
  talk: "talk"
};
export const objectTyp = {
  human: "human",
  object: "object",
  door: "door"
};
